import { ActionReducerMapBuilder, createAsyncThunk } from "@reduxjs/toolkit";
import { graphqlRequest } from "context/graphql/functions";
import { AppAsyncThunkConfig } from "store";
import { Category, State } from "./createEvent.store";

export const createAppAsyncThunk = createAsyncThunk.withTypes<AppAsyncThunkConfig>();

export const asyncMutations = {
  createEvent: createAppAsyncThunk(
    "createEvent/createEvent",
    async (eventData: { description: string, eventStartDate: Date, eventEndDate: Date, selectedCategory: Category, engineerName: string, engineerId: number | null }, { rejectWithValue, getState, extra: { sdk } }) => {
      if (!eventData.description || !eventData.eventStartDate || !eventData.eventEndDate) {
        return rejectWithValue("Missing values when creating event");
      }

      const response = await graphqlRequest(sdk.createEvent, {
        thunkName: "createEvent/createEvent",
        variables: {
          eventDetails: {
            description: eventData.description,
            categoryId: eventData.selectedCategory ? Number(eventData.selectedCategory.id) : null,
            eventStartDate: eventData.eventStartDate.toISOString(),  
            eventEndDate: eventData.eventEndDate.toISOString(),    
            engineerName: eventData.engineerName,
            engineerId: eventData.engineerId,
          },
        },
      });

      const { data, errors, queued } = response;

      if (errors) {
        return rejectWithValue(errors);
      }

      if (!data?.createEvent) {
        return rejectWithValue("Something went wrong");
      }

      if (data.createEvent.eventId === null || data.createEvent.eventId === undefined){
        return rejectWithValue("Invalid response from server");
      }

      return { queued, eventId: data.createEvent.eventId }; 
    }
  ),
};

export const mutationBuilder = (builder: ActionReducerMapBuilder<State>) => {
  builder.addCase(asyncMutations.createEvent.pending, (state) => {
    state.createEventLoading = true;
  });
  builder.addCase(asyncMutations.createEvent.rejected, (state) => {
    state.createEventLoading = false;
  });
  builder.addCase(asyncMutations.createEvent.fulfilled, (state, { payload }) => {
    state.createEventLoading = false;
    state.formValues = {
      allDayToggle: false,
      selectedCategory: null,
      description: "",
      eventStartDate: null,
      eventEndDate: null,
    };
    state.isDirty = false;
    state.errors = {};
    state.isValid = true;
  });
};
